export const NAME_REQUIRED_ERROR = 'Enter name';
export const LENGTH_ERROR = 'Should be between 2 and 50 characters';
export const SURNAME_REQUIRED_ERROR = 'Enter surname';
export const EMAIL_REQUIRED_ERROR = 'Enter email address';
export const EMAIL_PATTERN_ERROR = 'Please provide a valid email format';
export const PHONE_NUMBER_REQUIRED_ERROR = 'Enter phone number';
export const PHONE_NUMBER_PATTERN_ERROR = 'Please provide a valid phone number format';
export const INCORRECT_COMMISSION = 'Commission must be between 1 and 100';
export const INVALID_COMMISSION = 'Invalid commission';
